<script>
import CompanyResource from '../resources/company'
import CompanyImage from '../components/CompanyImage.vue'

export default {
    name: 'RecruitHome',
    components: {
        CompanyImage
    },
    data() {
        return {
            loading: true,
            companyResource: null,
        }
    },
    methods: {
        
    },
    async mounted() {
        let companyId = this.$route.params.companyId
        this.companyResource = await CompanyResource.detail(companyId, { resolveRelated: true })
        this.loading = false
    },
}
</script>

<template>
    <div v-if="!loading">
        <section class="py-md-5 gray">
            <b-container fluid>
                <b-row>
                    <b-col md="3" class="recruit-nav">
                        <div class="recruit-nav-inner section-heading mb-2">
                            <company-image :company-resource="companyResource" size="3rem" class="mb-3" />
                            <h4>{{ companyResource.attributes.name }}</h4>
                            <p>{{ companyResource.readonly['market_name'] }}</p>
                            <hr class="mt-4" />
                            <ul class="list-unstyled">
                                <li v-if="companyResource.attributes.tier < 1">
                                    <router-link :to="{ name: 'upgrade', params: { companyId: companyResource.id } }" class="text-magenta"><b-icon icon="patch-check-fll" /> Upgrade Your Account</router-link>
                                </li>
                                <li>
                                    <router-link :to="{ name: 'recruitHome', params: { companyId: companyResource.id } }"><b-icon icon="house-door" /> Job Listings</router-link>
                                </li>
                                <li v-if="companyResource.attributes.tier > 1">
                                    <router-link :to="{ name: 'recruitSource', params: { companyId: companyResource.id } }"><b-icon icon="search" /> Browse Candidates</router-link>
                                </li>
                                <li v-else>
                                    <span class="disabled text-muted"><b-icon icon="search" /> Browse Candidates</span>
                                </li>
                                <li>
                                    <router-link :to="{ name: 'recruitCompanyEdit', params: { companyId: companyResource.id }}"><b-icon icon="building" /> Company Profile</router-link>
                                </li>
                            </ul>
                        </div>
                    </b-col>
                    <b-col>
                        <div class="recruit-router-inner p-4">
                            <router-view :companyResource="companyResource"> </router-view>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </section>
    </div>
</template>

<style lang="scss">

.recruit-nav {

    ul li {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }

    .recruit-nav-inner {
        padding: 1rem;
        background: #fff;
    }
}

.recruit-router-inner {
    background: #fff;
}
</style>
